<template>
	<div class="pages" v-loading="listLoading">
		<div v-for="(item, index) in templateData.TemplateContent.Controls" :key="index">
			<Digit v-if="item.Property.Control == 'Number'" :data-val="item"></Digit>
			<Contact v-if="item.Property.Control == 'Condition'" :data-val="item"></Contact>
			<!--      @child-event="getDateVal"-->
			<Dates v-if="item.Property.Control == 'DateTime'" :data-val="item"></Dates>
			<Version v-if="item.Property.Control == 'Text'" @child-event="getTextVal" :data-val="item"></Version>
			<Money v-if="item.Property.Control == 'Money'" :data-val="item"></Money>
			<Tips v-if="item.Property.Control == 'Tips'" :data-val="item"></Tips>
			<File v-if="item.Property.Control == 'File'" :data-val="item"></File>
			<Table v-if="item.Property.Control == 'Table'" @child-event="tableOperation" :data-val="item"></Table>
			<Selector v-if="item.Property.Control == 'Selector'" @child-event="getSelectorVal" :data-val="item">
			</Selector>
			<Textarea v-if="item.Property.Control == 'Textarea'" :data-val="item"></Textarea>
			<Choose v-if="item.Property.Control == 'Contact'" @child-event="clickChoose" :data-val="item"></Choose>
			<CardAssemblyResources v-if="item.Property.Control == 'Card'" :data-val="item" @look="look">
			</CardAssemblyResources>
		</div>



		<Button class="submit-process" v-on:click="submit" v-bind:disabled="isDisabled" v-bind:loading="formLoading"
			size="large" type="primary">
			拿取
		</Button>
	</div>
</template>

<script>
	/**
	 * Version 为Text文本组件
	 */
	import Digit from "../components/Number.vue";
	import Contact from "../components/Contact.vue";
	import Version from "../components/Text.vue";
	import Money from "../components/Money.vue";
	import Tips from "../components/Tips.vue";
	import File from "../components/File.vue";
	import Dates from "../components/DateTime.vue";
	import Table from "../components/Table.vue";
	import Selector from "../components/Selector.vue";
	import Textarea from "../components/Textarea.vue";
	import Choose from "../components/Choose.vue";
	import stringUtils from "../assets/js/stringUtil.js";
	import {
		initWxConfig
	} from "../api/jssdk.js";
	import {
		getTemplateInfo,
		submitProcessCopy
	} from "@/api/approval";
	import CardAssemblyResources from "../components/CardAssemblyResources";


	import {
		getAllBorrowingInformation,
		receiverInformationFill,
		CheckTimeSlot,
		getBorrowingInformationForApprovalNo,
		borrowingInformationsFillT,
		receiverInformationFillForTemporary,
		checkByEmpNo
	} from "@/api/ResourceBorrowing";

	var isSubmit = false;

	var template = {
		TemplateContent: {
			Controls: [],
		},
	};
	export default {
		components: {
			Contact,
			Version,
			Money,
			Tips,
			File,
			Table,
			Digit,
			Selector,
			Textarea,
			Choose,
			Dates,
			CardAssemblyResources
		},
		data() {
			return {
				templateData: template,
				relationList: null,
				logInfo: null,
				templateId: "",
				spNo: null,
				formLoading: false,
				listLoading: false,
				isDisabled: false,
				listIsShow: false,
				equipmentName: null,
				borrowingList: [],
				borrowing: null,
				borrowings: [],
				flowId: null,
				submitTime: null
			};
		},
		created() {
			this.logInfo = this.getLoginUserInfo();
			initWxConfig(this);
			this.templateId = this.$route.query.templateId;
			this.spNo = this.$route.query.spNo;
			this.getTemplate();
			stringUtils.setAddIsShow(true);
		},
		methods: {
			clickChoose: async function(dataVal, name) {
				var that = this;
				window.wx.invoke(
					"selectEnterpriseContact", {
						fromDepartmentId: 0, // 必填，表示打开的通讯录从指定的部门开始展示，-1表示自己所在部门开始, 0表示从最上层开始
						mode: "single", // 必填，选择模式，single表示单选，multi表示多选
						type: ["department"], // 必填，选择限制类型，指定department、user中的一个或者多个
						selectedDepartmentIds: [], // 非必填，已选部门ID列表。用于多次选人时可重入，single模式下请勿填入多个id
						selectedUserIds: [], // 非必填，已选用户ID列表。用于多次选人时可重入，single模式下请勿填入多个id
					},
					async function(res) {
						if (res.err_msg === "selectEnterpriseContact:ok") {
							if (typeof res.result == "string") {
								res.result = JSON.parse(res
									.result); //由于目前各个终端尚未完全兼容，需要开发者额外判断result类型以保证在各个终端的兼容性
							}
							// 已选的部门列表
							var depart = res.result.departmentList[0];
							dataVal.Values = [];
							dataVal.Values.push([depart.id, depart.name]);
							dataVal.Value = depart.name;
						}
					}
				);
			},
			tableOperation(val, type, datas) {
				let controls = this.templateData.TemplateContent.Controls.filter(control => control.Property.Title[0].Text.indexOf("临时拿取") > -1)
				if (type === "资源借用") {
					let children = datas.Config.Table.Children
					this.QueryTimeConflict(children)
				} else if ("articleNameSelect" === type) {
					let vals = this.getSelectValAll(controls)
					let children = datas.Config.Table.Children
					this.QueryTimeConflict(children)
					if (this.isRepeat(vals)) {
						for (var i = 0; i < children.length; i++) {
							let child = children[i]
							if (child.Property.Title[0].Text === "选择设备") {
								setTimeout(() => {
									this.$set(child, "Value", "")
								}, 50)
								break
							}
						}
						this.Message({
							message: "临时拿取，同一设备不能重复选择",
							type: "error",
							duration: 3 * 1000
						});
						
					}
				} else {
					this.tableoperation(val, type, datas, this);
				}
			},
			/**
			 * 判断是否有重复项
			 * @param {Object} arr
			 */
			isRepeat(arr) {
				let flag = false;
				let s = arr.join(",") + ",";
				for (let i = 0; i < arr.length; i++) {
					if (s.replace(arr[i] + ",", "").indexOf(arr[i] + ",") > -1) {
						flag = true
						break;
					}
				}
				return flag
			},
			/**
			 * 获取全部table中的select值
			 * @param {Object} controls
			 */
			getSelectValAll(controls) {
				let result = [];
				controls.forEach(control => {
					let children = control.Config.Table.Children
					children.forEach(child => {
						if (child.Property.Title[0].Text == "选择设备") {
							let options = child.Config.Selector.Options
							options.forEach(option => {
								if (option.Key == child.Value) {
									result.push(option.Value[0].Text)
								}
							})
						}
					})
				})
				return result
			},
			QueryTimeConflict(children) {
				let articleName = "",startTime, endTime,childList = [];
				children.forEach(child => {
					if (child.Property.Title[0].Text === "选择设备") {
						child.Config.Selector.Options.forEach(option => {
							if (option.Key === child.Value) {
								articleName = option.Value[0].Text
							}
						})
					}
					if (child.Property.Title[0].Text === "借用开始时间") {
						startTime = child.Value
						if(startTime !== null && startTime !== ""){
							childList.push(child)
						}
					}
					if (child.Property.Title[0].Text === "借用结束时间") {
						endTime = child.Value
						if(endTime !== null && endTime !== ""){
							childList.push(child)
						}
					}
				})
				if (startTime){
					let iosStartTime = startTime.replace(/-/g,"/")
					if(new Date(iosStartTime) < new Date()){
						startTime = null
						this.Message({
							message: "开始时间不能小于当前时间",
							type: "error",
							duration: 4 * 1000
						});
						childList.forEach(item => {
							setTimeout(() => {
								item.Value = ''
							}, 10);
						})
					}
				}
				if (startTime && endTime){
					let iosStartTime = startTime.replace(/-/g,"/")
					let iosEndTime = endTime.replace(/-/g,"/")
					if(iosEndTime === iosStartTime){
						startTime = null
						endTime = null
						this.Message({
							message: "结束时间不能等于开始时间",
							type: "error",
							duration: 4 * 1000
						});
						childList.forEach(item => {
							setTimeout(() => {
								item.Value = ''
							}, 10);
						})
					}
					if(new Date(iosEndTime) < new Date(iosStartTime)){
						startTime = null
						endTime = null
						this.Message({
							message: "结束时间不能小于开始时间",
							type: "error",
							duration: 4 * 1000
						});
						childList.forEach(item => {
							setTimeout(() => {
								item.Value = ''
							}, 10);
						})
					}
				}
				if (startTime && endTime && articleName) {
					this.isDisabled = false
					CheckTimeSlot(startTime, endTime, articleName).then(res => {
						let messages = [];
						let bodys = res.Body;
						if (bodys !== null && bodys.length > 0) {
							for (var i = 0; i < bodys.length; i++) {
								let body = bodys[i]
								const h = this.$createElement;
								let borrowing = body.BorrowingInformation
								messages = []
								messages.push("此设备在该时间段已被其他人借用")
								messages.push(
									`申请人: ${borrowing.BorrowerName} ${borrowing.BorrowerEmpNo} ${borrowing.BorrowerDept}`
								)
								messages.push(`设备名称: ${borrowing.EquipmentName}`)
								messages.push(
									`借用时间: ${borrowing.BorrowingStartTime} - ${borrowing.BorrowingEndTime}`)
								children.forEach(child => {
									let text = child.Property.Title[0].Text
									if (text === "借用开始时间" || text === "借用结束时间") {
										child.Value = ""
									}
								})
								setTimeout(() => {
									this.Message({
										message: messages.join("<br/>"),
										type: "error",
										duration: 5 * 1000,
										dangerouslyUseHTMLString: true
									});
								}, 80)
							}
						}
					})
				}
			},
			getSelectorVal: async function(val, name) {},
			getTextVal() {},
			buildObject() {
				var ReceiverInformation = {
					/**
					 * 拿取者姓名
					 * */
					TakeName: "",
					/**
					 * 拿取者工号
					 */
					TakeEmpNo: "",
					/**
					 * 拿取者部门
					 */
					TakeDept: "",
					/**
					 * 拿取时间
					 */
					TakeTime: "",
					/**
					 * 企业微信流程编号
					 * */
					ApprovalNumber: "",
				};
				return this.filling(ReceiverInformation);
			},
			/**
			 * 填充数据
			 * @param obj
			 * @returns {*}
			 */
			filling(obj) {
				obj.TakeName = this.logInfo.EmpName;
				obj.TakeEmpNo = this.logInfo.EmpNo;
				obj.TakeDept = this.logInfo.DeptName;
				var data = new Date();
				var month =
					data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				this.submitTime =
					`${data.getFullYear()}-${month}-${date} ${data.getHours()}:${
					data.getMinutes() > 9 ? data.getMinutes() : "0" + data.getMinutes()
					}:${data.getSeconds() > 9 ? data.getSeconds() : "0" + data.getSeconds()}`;
				obj.TakeTime = this.submitTime;
				return obj;
			},
			getNowTime() {
				var data = new Date();
				var month =
					data.getMonth() < 9 ? "0" + (data.getMonth() + 1) : data.getMonth() + 1;
				var date = data.getDate() <= 9 ? "0" + data.getDate() : data.getDate();
				return `${data.getFullYear()}-${month}-${date} ${data.getHours()}:${
					data.getMinutes() > 9 ? data.getMinutes() : "0" + data.getMinutes()
					}:${data.getSeconds() > 9 ? data.getSeconds() : "0" + data.getSeconds()}`;
			},
			look(val, borrowing) {
				this.isDisabled = false;
				this.borrowings = borrowing
				if (this.borrowings.length === 0) {
					let controls = JSON.parse(JSON.stringify(this.templateData.TemplateContent.Controls.filter(control => control.Property.Title[0]
					.Text.indexOf("临时拿取") > -1)));
					let flag = this.analysisIsNull(controls)
					if(flag){
						this.isDisabled = true
					}
				}
			},
			sortDownDate(a, b) {
				let TimeA = a.BorrowingInformation.BorrowingStartTime.replace(new RegExp('-', 'g'), "/")
				let TimeB = b.BorrowingInformation.BorrowingStartTime.replace(new RegExp('-', 'g'), "/")
				return Date.parse(TimeA) - Date.parse(TimeB);
			},
			getTemplate: async function() {
				var that = this;
				that.listLoading = true;
				that.isDisabled = true;
				var empNo = this.logInfo.EmpNo
				await getTemplateInfo(this.templateId).then(async (response) => {
					var controls = response.Body;
					var that = this;
					let executiveDirector = [];
					let isViolation = false
					await checkByEmpNo(empNo).then(res => {
					  let bodys = res.Body;
					  if (!bodys) {
					    isViolation = true
					  }
					  for (let i = 0; i < controls.TemplateContent.Controls.length; i++) {
					  	let item = controls.TemplateContent.Controls[i];
					  	if (item.Property.Title[0].Text === "审批或签控件") {
					  		item.IsShow = false;
					  	}
					  	if (item.Property.Title[0].Text === "申请记录") {
					  		item.IsShow = false;
					  		item.Value = "无借用记录";
					  		this.Disable = true;
					  	}
					  	if (item.Property.Title[0].Text === "借用信息Id") {
					  		item.IsShow = false;
					  	}
					  	if (item.Property.Title[0].Text === "临时拿取") {
					  		if(isViolation){
					  			item.IsShow = false
					  		}
					  		let children = item.Config.Table.Children;
					  		children.forEach((child) => {
					  			if (child.Property.Title[0].Text === "借用开始时间" || child.Property.Title[
					  					0].Text === "借用结束时间") {
					  				child.Property.Control = "DateTime"
					  			}
					  		})
					  	}
					  	if (item.Property.Title[0].Text === "拿取者") {
					  		let children = item.Config.Table.Children;
					  		children.forEach((child) => {
					  			if (child.Property.Title[0].Text === "姓名") {
					  				child.Value = that.logInfo.EmpName;
					  				child.Disable = true;
					  			}
					  			if (child.Property.Title[0].Text === "工号") {
					  				child.Value = that.logInfo.EmpNo;
					  				child.Disable = true;
					  			}
					  			if (child.Property.Title[0].Text === "部门") {
					  				child.Value = that.logInfo.DeptName;
					  				child.Disable = true;
					  			}
					  		});
					  	}
					  	if (item.Property.Title[0].Text === "表单信息") {
					  		item.IsShow = false;
					  	}
					  }
					})
					this.templateData = this.assignControl(controls, that.logInfo);
					this.listLoading = false;
				});
				getAllBorrowingInformation().then((res) => {
					let bodys = res.Body;
					//不显示借用时间逾期的记录
					if (bodys !== null) {
						bodys = bodys.filter(e => new Date(e.BorrowingInformation.BorrowingEndTime.replace(
								new RegExp('-', 'g'), "/")) >
							new Date())
					}
					if (bodys !== null && bodys.length > 0) {
						this.listIsShow = true;
						bodys = bodys.sort(this.sortDownDate)
						this.borrowingList = bodys;
						let controls = this.templateData.TemplateContent.Controls
						let control = {
							"Property": {
								"Control": "Card",
								"Title": [{
									"Text": "借用记录"
								}]
							},
							"listIsShow": this.listIsShow,
							"borrowingList": this.borrowingList
						}
						controls.splice(controls.length - 1, 0, control)
					} else {
						this.listIsShow = false;
						this.borrowingList = [];
						this.templateData.TemplateContent.Controls.forEach((item) => {
							if (item.Property.Title[0].Text === "申请记录") {
								item.IsShow = true;
								this.Message({
									message: "无申请记录",
									type: "error",
									duration: 3 * 1000,
								});
								this.isDisabled = true;
							}
						});
					}
					this.templateData.TemplateContent.Controls.forEach(item => {
						if (item.Property.Title !== undefined) {
							if (item.Property.Title[0].Text === "拿取者") {
								item.addIsShow = false
							}
						}
					})
				});
			},
			analysisIsNull(controls) {
				let result = false
				controls.forEach(control => {
					let children = control.Config.Table.Children;
					let valIsNull = children.filter(e => e.Value === null || e.Value === "");
					if (valIsNull.length > 0) {
						result = true
					}
				})
				return result
			},
			selectIsError(borrowings) {
				let results = this.Select(borrowings, e => e.BorrowingInformation.EquipmentName)
				if (this.isRepeat(results)) {
					return true
				}
				return false
			},
			Select(arr, callback) {
				let results = []
				for (var i = 0; i < arr.length; i++) {
					let item = callback(arr[i])
					if (item) {
						results.push(item)
					}
				}
				return results
			},
			analysisAllOwned(controls) {
				if (this.borrowings.length > 0) {
					if (controls.length > 1) {
						return true
					}
					let children = controls[0].Config.Table.Children;
					return children.filter(e => e.Value !== null && e.Value !== "").length > 0;
				}
			},
			
			ComponentConvertBorrow(control) {
				//构建申请信息
				let IntermediateEntity = {
					/**
					 * 借用者姓名
					 */
					EmpName: "",

					/**
					 * 借用者工号
					 */
					EmpNo: "",

					/**
					 * 借用者部门
					 */
					DeptName: "",

					/**
					 * 设备名称
					 */
					EquipmentName: "",

					/**
					 * 多次借用
					 * */
					TimeCollection: [],

					/**
					 * 提交时间
					 */
					SubmissionTime: "",

					/**
					 * 企业微信id
					 * */
					ApprovalNumber: ""
				};
				IntermediateEntity.EmpNo = this.logInfo.EmpNo
				IntermediateEntity.EmpName = this.logInfo.EmpName
				IntermediateEntity.DeptName = this.logInfo.DeptName
				IntermediateEntity.SubmissionTime = this.getNowTime()
				let children = control.Config.Table.Children
				let TimeSlot = {
					StartTime: null,
					EndTime: null
				}
				children.forEach(child => {
					let text = child.Property.Title[0].Text
					if (text === "选择设备") {
						let options = child.Config.Selector.Options
						options.forEach(option => {
							if (option.Key === child.Value) {
								IntermediateEntity.EquipmentName = option.Value[0].Text
							}
						})
					} else if (text === "借用开始时间") {
						TimeSlot.StartTime = child.Value
					} else if (text === "借用结束时间") {
						TimeSlot.EndTime = child.Value
					}
				})
				IntermediateEntity.TimeCollection.push(TimeSlot)
				return IntermediateEntity;
			},
			submit: async function() {
				this.isDisabled = true;
				//判断
				let flag, notSelect = false;
				let controls = this.templateData.TemplateContent.Controls.filter(control => control.Property.Title[0]
					.Text.indexOf("临时拿取") > -1);
				if (this.borrowings.length <= 0) {
					//判断信息是否填写完整
					flag = this.analysisIsNull(controls)
					if (flag) {
						this.isDisabled = false;
						this.Message({
							message: "临时拿取信息未填写完整",
							type: "error",
							duration: 3 * 1000,
						});
						return
					}
					notSelect = true
				}
				// 判断是否存在临时拿取和拿取两种情况
				flag = this.analysisAllOwned(controls)
				if (flag) {
					this.isDisabled = false;
					this.Message({
						message: "拿取【已借用】和临时拿取不可同时选择<br>请选择其中一种提交",
						type: "error",
						duration: 3 * 1000,
						dangerouslyUseHTMLString: true
					});
					return
				}
				//判断拿取时选择是否有误
				let isError = this.selectIsError(this.borrowings)
				if (isError) {
					this.isDisabled = false;
					this.Message({
						message: "同一设备，不同借用时间，不能同时拿取！",
						type: "error",
						duration: 4 * 1000,
						dangerouslyUseHTMLString: true
					});
					return;
				}
				//构建
				var receiverInformation = this.buildObject();
				let isSuccess = true
				if (this.borrowings.length === 1) {
					let borrowing = this.borrowings[0].BorrowingInformation
					//审批人所见
					this.templateData.TemplateContent.Controls.forEach((item) => {
						if (item.Property.Title[0].Text === "审批或签控件") {
							item.Values = [];
							item.Values.push([borrowing.BorrowerEmpNo, borrowing.BorrowerName]);
						}
						if (item.Property.Title[0].Text === "关联申请单") {
							item.Value = borrowing.ApprovalNumber;
						}
						if (item.Property.Title[0].Text === "表单信息") {
							let children = item.Config.Table.Children;
							for (let k = 0; k < children.length; k++) {
								let child = children[k]
								if (child.Property.Title[0].Text === "借用人名字") {
									child.Value = borrowing.BorrowerName;
									continue
								}
								if (child.Property.Title[0].Text === "借用人工号") {
									child.Value = borrowing.BorrowerEmpNo;
									continue
								}
								if (child.Property.Title[0].Text === "借用人部门") {
									child.Value = borrowing.BorrowerDept;
									continue
								}
								if (child.Property.Title[0].Text === "设备名称") {
									child.Value = borrowing.EquipmentName;
									continue
								}
								if (child.Property.Title[0].Text === "借用开始时间") {
									child.Value = borrowing.BorrowingStartTime;
									continue
								}
								if (child.Property.Title[0].Text === "借用结束时间") {
									child.Value = borrowing.BorrowingEndTime;
									continue
								}
								if (child.Property.Title[0].Text === "拿取时间") {
									child.Value = this.submitTime;
									continue
								}
							}
						}
					});
					//数据校验
					if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
						this.isDisabled = false;
						return;
					}
					
					var SummaryList = [];

					var info = {
						SummaryInfo: []
					};
					info.SummaryInfo = [];
					info.SummaryInfo.push({
						Text: `拿取者： ${this.logInfo.EmpName} ${this.logInfo.EmpNo}  ${this.logInfo.DeptName}`,
						Lang: "zh_CN",
					});
					SummaryList.push(info);

					var info = {
						SummaryInfo: []
					};
					info.SummaryInfo = [];
					info.SummaryInfo.push({
						Text: "设备名称：" + " " + borrowing.EquipmentName,
						Lang: "zh_CN",
					});
					SummaryList.push(info);

					var info = {
						SummaryInfo: []
					};
					info.SummaryInfo = [];
					info.SummaryInfo.push({
						Text: `借用时间: ${borrowing.BorrowingStartTime} - ${borrowing.BorrowingEndTime}`,
						Lang: "zh_CN",
					});
					SummaryList.push(info);

					var info = {
						SummaryInfo: []
					};
					info.SummaryInfo = [];
					info.SummaryInfo.push({
						Text: `拿取时间: ${receiverInformation.TakeTime}`,
						Lang: "zh_CN",
					});
					SummaryList.push(info);
					this.templateData.SummaryList = SummaryList;
					let templateData = JSON.parse(JSON.stringify(this.templateData))
					let controls = templateData.TemplateContent.Controls
					templateData.TemplateContent.Controls = controls.filter(e => e.Property.Control !== "Card"&& e.Property.Title[0].Text.indexOf("临时拿取") === -1)
					templateData.TemplateContent.Controls.forEach(item => {
						if (item.Property.Title[0].Text.indexOf("临时拿取") > -1) {
							let children = item.Config.Table.Children;
							children.forEach((child) => {
								if (child.Property.Title[0].Text === "借用开始时间" || child.Property.Title[0].Text === "借用结束时间") {
									child.Property.Control = "Text"
								}
							})
						}
					})
					templateData.SummaryList = SummaryList;
					let spNo = borrowing.ApprovalNumber;
					//提交
					await submitProcessCopy(
							this.templateId,
							this.logInfo.EmpNo,
							spNo, {
								"dto": templateData
							},
							this.borrowings[0].FlowId
						)
						.then((response) => {
							if (response.Body.ErrCode !== 0) {
								this.Message({
									message: "申请失败，请稍后重试",
									type: "error",
									duration: 3 * 1000,
								});
							} else {
								receiverInformation.ApprovalNumber = response.Body.SpNo;
								//保存数据
								receiverInformationFill(this.borrowings[0].ID, receiverInformation);
								this.Message({
									message: "申请成功",
									type: "success",
									duration: 3 * 1000,
								});
								setTimeout(() => {
									this.$router.push("/index");
								}, 1000);
							}
						})
						.catch((err) => {
							this.isDisabled = false;
						})
						.finally(() => {
							isSubmit = false;
							this.listLoading = false;
						});
				} else if (this.borrowings.length > 1) {
					for (let i = 0; i < this.borrowings.length; i++) {
						let borrowing = this.borrowings[i].BorrowingInformation
						//审批人所见
						for (let j = 0; j < this.templateData.TemplateContent.Controls.length; j++) {
							const item = this.templateData.TemplateContent.Controls[j];
							if (item.Property.Title[0].Text === "审批或签控件") {
								item.Values = [];
								item.Values.push([borrowing.BorrowerEmpNo, borrowing.BorrowerName]);
							}
							if (item.Property.Title[0].Text === "关联申请单") {
								item.Value = borrowing.ApprovalNumber;
							}
							if (item.Property.Title[0].Text === "表单信息") {
								let children = item.Config.Table.Children;
								for (let k = 0; k < children.length; k++) {
									let child = children[k]
									if (child.Property.Title[0].Text === "借用人名字") {
										child.Value = borrowing.BorrowerName;
										continue
									}
									if (child.Property.Title[0].Text === "借用人工号") {
										child.Value = borrowing.BorrowerEmpNo;
										continue
									}
									if (child.Property.Title[0].Text === "借用人部门") {
										child.Value = borrowing.BorrowerDept;
										continue
									}
									if (child.Property.Title[0].Text === "设备名称") {
										child.Value = borrowing.EquipmentName;
										continue
									}
									if (child.Property.Title[0].Text === "借用开始时间") {
										child.Value = borrowing.BorrowingStartTime;
										continue
									}
									if (child.Property.Title[0].Text === "借用结束时间") {
										child.Value = borrowing.BorrowingEndTime;
										continue
									}
									if (child.Property.Title[0].Text === "拿取时间") {
										child.Value = this.submitTime;
										continue
									}
								}
							}
						}
						//数据校验
						if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
							this.isDisabled = false;
							return;
						}
						var SummaryList = [];

						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: `拿取者： ${this.logInfo.EmpName} ${this.logInfo.EmpNo}  ${this.logInfo.DeptName}`,
							Lang: "zh_CN",
						});
						SummaryList.push(info);

						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: "设备名称：" + " " + borrowing.EquipmentName,
							Lang: "zh_CN",
						});
						SummaryList.push(info);

						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: `借用时间: ${borrowing.BorrowingStartTime} - ${borrowing.BorrowingEndTime}`,
							Lang: "zh_CN",
						});
						SummaryList.push(info);

						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: `拿取时间: ${receiverInformation.TakeTime}`,
							Lang: "zh_CN",
						});
						SummaryList.push(info);
						let templateData = JSON.parse(JSON.stringify(this.templateData))
						let controls = templateData.TemplateContent.Controls
						templateData.TemplateContent.Controls = controls.filter(e => e.Property.Control !== "Card" && e.Property.Title[0].Text.indexOf("临时拿取") === -1)
						templateData.TemplateContent.Controls.forEach(item => {
							if (item.Property.Title[0].Text.indexOf("临时拿取") > -1) {
								let children = item.Config.Table.Children;
								children.forEach((child) => {
									if (child.Property.Title[0].Text === "借用开始时间" || child.Property.Title[0].Text === "借用结束时间") {
										child.Property.Control = "Text"
									}
								})
							}
						})
						templateData.SummaryList = SummaryList;
						let spNo = borrowing.ApprovalNumber;
						//提交
						await submitProcessCopy(
								this.templateId,
								this.logInfo.EmpNo,
								spNo, {
									"dto": templateData
								},
								this.borrowings[i].FlowId
							)
							.then((response) => {
								if (response.Body.ErrCode !== 0) {
									this.Message({
										message: "申请失败，请稍后重试",
										type: "error",
										duration: 3 * 1000,
									});
								} else {
									receiverInformation.ApprovalNumber = response.Body.SpNo;
									//保存数据
									receiverInformationFill(this.borrowings[i].ID, receiverInformation);
								}
							})
							.catch((err) => {
								this.isDisabled = false;
								isSuccess = false
							})
							.finally(() => {
								isSubmit = false;
								this.listLoading = false;
							});
					}
					if(isSuccess){
						this.Message({
							message: "申请成功",
							type: "success",
							duration: 3 * 1000,
						});
						setTimeout(() => {
							this.$router.push("/index");
						}, 1000);
					}
				} 
				else if (notSelect) {
					/**
					 * let templateinfo;
					await getTemplateInfo("BsAaj2jBsepHZNs7ACNVdZiVsv4yjT9mSJiYwriB2").then((response) => {
						templateinfo = response.Body
					})
					//==申请
					for (var i = 0; i < controls.length; i++) {
						let control = controls[i]
						let borrow = this.ComponentConvertBorrow(control)
						let component;
						const that = this
						for (var j = 0; j < templateinfo.TemplateContent.Controls.length; j++) {
							let item = templateinfo.TemplateContent.Controls[j]
							let text = item.Property.Title[0].Text
							if (text === "姓名") {
								item.Value = borrow.EmpName
							}
							if (text === "工号") {
								item.Value = borrow.EmpNo
							}
							if (text === "部门") {
								item.Value = borrow.DeptName
							}
							if (text === "借用信息") {
								let children = item.Config.Table.Children
								for (var p = 0; p < children.length; p++) {
									let child = children[p]
									if (child.Property.Title[0].Text === "选择设备") {
										let options = child.Config.Selector.Options
										for (var n = 0; n < options.length; n++) {
											let option = options[n]
											if (option.Value[0].Text === borrow.EquipmentName) {
												child.Value = option.Key
												break
											}
										}
									}
									if (child.Property.Title[0].Text === "借用开始时间") {
										child.Value = borrow.TimeCollection[0].StartTime
									}
									if (child.Property.Title[0].Text === "借用结束时间") {
										child.Value = borrow.TimeCollection[0].EndTime
									}
								}
							}
						}
						component = this.assignControl(templateinfo, that.logInfo)
						var SummaryList = [];

						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: "借用者：" +
								" " +
								this.logInfo.EmpName +
								" " +
								this.logInfo.EmpNo +
								" " +
								this.logInfo.DeptName,
							Lang: "zh_CN",
						});
						SummaryList.push(info);

						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: "设备名称：" + " " + borrow.EquipmentName,
							Lang: "zh_CN",
						});
						SummaryList.push(info);
						borrow.TimeCollection.forEach(item => {
							var info = {
								SummaryInfo: []
							};
							info.SummaryInfo = [];
							info.SummaryInfo.push({
								Text: "借用时间：" + `${item.StartTime} - ${item.EndTime}`,
								Lang: "zh_CN",
							});
							SummaryList.push(info);
						})
						component.SummaryList = SummaryList;
						//提交
						await submitProcessCopy(
								"BsAaj2jBsepHZNs7ACNVdZiVsv4yjT9mSJiYwriB2",
								this.logInfo.EmpNo,
								this.spNo, {
									"dto": component,
									"intermediateEntityDto": borrow
								}
							)
							.then(async (response) => {
								if (response.ErrCode !== 0) {
									this.Message({
										message: response.ErrMsg,
										type: "error",
										duration: 3 * 1000,
									});
								} else {
									//保存数据
									// this.fillingDto(response.Body.SpNo)
									console.log("申请成功");
									let queBorrowing;
									/**
									await getBorrowingInformationForApprovalNo(response.Body.SpNo).then(async res => {
										this.borrowings = res.Body
										//拿取==
										for (let i = 0; i < this.borrowings.length; i++) {
											let borrowing = this.borrowings[i].BorrowingInformation
											//审批人所见
											for (let j = 0; j < this.templateData.TemplateContent.Controls
												.length; j++) {
												const item = this.templateData.TemplateContent.Controls[j];
												if (item.Property.Title[0].Text === "审批或签控件") {
													item.Values = [];
													item.Values.push([borrowing.BorrowerEmpNo, borrowing
													.BorrowerName]);
												}
												if (item.Property.Title[0].Text === "关联申请单") {
													item.Value = borrowing.ApprovalNumber;
												}
												if (item.Property.Title[0].Text === "表单信息") {
													let children = item.Config.Table.Children;
													children.forEach((child) => {
														if (child.Property.Title[0].Text === "借用人名字") {
															child.Value = borrowing.BorrowerName;
														}
														if (child.Property.Title[0].Text === "借用人工号") {
															child.Value = borrowing.BorrowerEmpNo;
														}
														if (child.Property.Title[0].Text === "借用人部门") {
															child.Value = borrowing.BorrowerDept;
														}
														if (child.Property.Title[0].Text === "设备名称") {
															child.Value = borrowing.EquipmentName;
														}
														if (child.Property.Title[0].Text === "借用开始时间") {
															child.Value = borrowing.BorrowingStartTime;
														}
														if (child.Property.Title[0].Text === "借用结束时间") {
															child.Value = borrowing.BorrowingEndTime;
														}
														if (child.Property.Title[0].Text === "拿取时间") {
															child.Value = this.submitTime;
														}
													});
												}
											}
											//数据校验
											if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
												return;
											}
											this.isDisabled = true;
											var SummaryList = [];
										
											var info = {
												SummaryInfo: []
											};
											info.SummaryInfo = [];
											info.SummaryInfo.push({
												Text: `拿取者： ${this.logInfo.EmpName} ${this.logInfo.EmpNo}  ${this.logInfo.DeptName}`,
												Lang: "zh_CN",
											});
											SummaryList.push(info);
										
											var info = {
												SummaryInfo: []
											};
											info.SummaryInfo = [];
											info.SummaryInfo.push({
												Text: "设备名称：" + " " + borrowing.EquipmentName,
												Lang: "zh_CN",
											});
											SummaryList.push(info);
										
											var info = {
												SummaryInfo: []
											};
											info.SummaryInfo = [];
											info.SummaryInfo.push({
												Text: `借用时间: ${borrowing.BorrowingStartTime} - ${borrowing.BorrowingEndTime}`,
												Lang: "zh_CN",
											});
											SummaryList.push(info);
										
											var info = {
												SummaryInfo: []
											};
											info.SummaryInfo = [];
											info.SummaryInfo.push({
												Text: `拿取时间: ${receiverInformation.TakeTime}`,
												Lang: "zh_CN",
											});
											SummaryList.push(info);
											let templateData = JSON.parse(JSON.stringify(this.templateData))
											let controls = templateData.TemplateContent.Controls
											templateData.TemplateContent.Controls = controls.filter(e => e.Property.Control !== "Card")
											templateData.TemplateContent.Controls.forEach(item => {
												if (item.Property.Title[0].Text.indexOf("临时拿取") > -1) {
													let children = item.Config.Table.Children;
													children.forEach((child) => {
														if (child.Property.Title[0].Text === "借用开始时间" || child.Property.Title[0].Text === "借用结束时间") {
															child.Property.Control = "Text"
														}
													})
												}
											})
											templateData.SummaryList = SummaryList;
											console.log(templateData);
											let spNo = borrowing.ApprovalNumber;
											//提交
										 	await submitProcessCopy(
													this.templateId,
													this.logInfo.EmpNo,
													spNo, {
														"dto": templateData
													},
													borrowing.FlowId
												)
												.then((response) => {
													if (response.Body.ErrCode !== 0) {
														this.Message({
															message: "申请失败，请稍后重试",
															type: "error",
															duration: 3 * 1000,
														});
													} else {
														receiverInformation.ApprovalNumber = response.Body.SpNo;
														//保存数据
														receiverInformationFill(this.borrowings[i].ID,
															receiverInformation);
														this.Message({
															message: "申请成功",
															type: "success",
															duration: 3 * 1000,
														});
														setTimeout(() => {
															this.$router.push("/index");
														}, 1000);
													}
												})
												.catch((err) => {
													this.isDisabled = false;
												})
												.finally(() => {
													isSubmit = false;
													this.listLoading = false;
												});
										}
									})
								}
							})
							.catch((err) => {
								this.isDisabled = false;
							})
							.finally(() => {
								isSubmit = false;
								this.listLoading = false;
							});
					}
					 */
					for (var i = 0; i < this.templateData.TemplateContent.Controls.filter(control => control.Property.Title[0].Text.indexOf("临时拿取") > -1).length; i++) {
						let control = this.templateData.TemplateContent.Controls.filter(control => control.Property.Title[0].Text.indexOf("临时拿取") > -1)[i]
						let borrow = this.ComponentConvertBorrow(control)
						let component;
						const that = this
						for (let j = 0; j < this.templateData.TemplateContent.Controls.length; j++) {
							const item = this.templateData.TemplateContent.Controls[j];
							if (item.Property.Title[0].Text === "审批或签控件") {
								item.Values = [];
								item.Values.push([that.logInfo.EmpNo, that.logInfo.EmpName]);
							}
							if (item.Property.Title[0].Text === "关联申请单") {
								item.Value = "";
							}
							if (item.Property.Title[0].Text === "表单信息") {
								let children = item.Config.Table.Children;
								for (let k = 0; k < children.length; k++) {
									let child = children[k]
									if (child.Property.Title[0].Text === "借用人名字") {
										child.Value = that.logInfo.EmpName;
										continue
									}
									if (child.Property.Title[0].Text === "借用人工号") {
										child.Value = that.logInfo.EmpNo;
										continue
									}
									if (child.Property.Title[0].Text === "借用人部门") {
										child.Value = that.logInfo.DeptName;
										continue
									}
									if (child.Property.Title[0].Text === "设备名称") {
										child.Value = borrow.EquipmentName;
										continue
									}
									if (child.Property.Title[0].Text === "借用开始时间") {
										child.Value = borrow.TimeCollection[0].StartTime;
										continue
									}
									if (child.Property.Title[0].Text === "借用结束时间") {
										child.Value = borrow.TimeCollection[0].EndTime;
										continue
									}
									if (child.Property.Title[0].Text === "拿取时间") {
										child.Value = this.submitTime;
										continue
									}
								}
							}
						}
						//数据校验
						if (!this.submitValidate(this.templateData.TemplateContent.Controls)) {
							this.isDisabled = false;
							return;
						}
						var SummaryList = [];
						
						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: `拿取者： ${this.logInfo.EmpName} ${this.logInfo.EmpNo}  ${this.logInfo.DeptName}`,
							Lang: "zh_CN",
						});
						SummaryList.push(info);
						
						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: "设备名称：" + " " + borrow.EquipmentName,
							Lang: "zh_CN",
						});
						SummaryList.push(info);
						
						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: `借用时间: ${borrow.TimeCollection[0].StartTime} - ${borrow.TimeCollection[0].EndTime}`,
							Lang: "zh_CN",
						});
						SummaryList.push(info);
						
						var info = {
							SummaryInfo: []
						};
						info.SummaryInfo = [];
						info.SummaryInfo.push({
							Text: `拿取时间: ${receiverInformation.TakeTime}`,
							Lang: "zh_CN",
						});
						SummaryList.push(info);
						let templateData = JSON.parse(JSON.stringify(this.templateData))
						let controls = templateData.TemplateContent.Controls
						templateData.TemplateContent.Controls = controls.filter(e => e.Property.Control !== "Card" && e.Property.Title[0].Text.indexOf("临时拿取") === -1)
						templateData.TemplateContent.Controls.forEach(item => {
							if(item.Property.Title[0].Text === "表单信息"){
								item.Property.Title[0].Text = "临时拿取信息"
							}
						})
						templateData.SummaryList = SummaryList;
						await submitProcessCopy(
								this.templateId,
								this.logInfo.EmpNo,
								this.spNo, {
									"dto": templateData
								},
								undefined
							)
							.then((response) => {
								if (response.Body.ErrCode !== 0) {
									this.Message({
										message: "申请失败，请稍后重试",
										type: "error",
										duration: 3 * 1000,
									});
								} else {
									receiverInformation.ApprovalNumber = response.Body.SpNo;
									//保存数据
									receiverInformationFillForTemporary({
										"receiverInformationDto" : receiverInformation,
										"intermediateEntityDto" : borrow,
									}).then(res => {
										console.log(res);
									});
									
								}
							})
							.catch((err) => {
								isSuccess = false
								this.isDisabled = false;
							})
							.finally(() => {
								isSubmit = false;
								this.listLoading = false;
							});
					}
					if(isSuccess){
						this.Message({
							message: "申请成功",
							type: "success",
							duration: 3 * 1000,
						});
						setTimeout(() => {
							this.$router.push("/index");
						}, 1000);
					}
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.pricing-list {
		padding: 10px;
		margin-top: 0px;

		.totle {
			font-size: 12px;
			margin-top: 10px;

			span {
				color: #ff4346;
				padding: 0 4px;
			}
		}

		.pricing-item {
			width: 100%;
			background: #ffffff;
			position: relative;
			padding: 8px;
			margin-top: 10px;
			border-radius: 6px;
			box-shadow: 6px 6px 6px #cccccc;

			.title {
				font-size: 13px;
				color: #585354;
				line-height: 1.8;
				width: calc(100% - 40px);
				white-space: nowrap;
				text-overflow: ellipsis;
				overflow: hidden;
				padding-bottom: 4px;
			}

			.applicant-time {
				color: #585354;
				font-size: 12px;
				line-height: 1.7;

				div.applicant {
					width: 80%;
					float: left;
				}

				div.time {
					width: 40%;
					float: right;
					text-align: right;
				}
			}

			.label {
				position: absolute;
				right: 5px;
				top: 10px;
			}

			.waiting-pricing {
				color: #3fc243;
			}

			.waiting-check {
				color: #55acee;
			}
		}

		.pricing-list-current {
			border: 2px solid #b9d5ec;
			box-shadow: 6px 6px 6px #78b4e6;
		}

		.pricing-item:first-child {
			margin-top: 0;
		}
	}
</style>
